<template>
    <ServicePageLayout
        title="Разработка сайтов под ключ"
        description="Создаю современные сайты для бизнеса и частных клиентов: лендинги, сайты-визитки, корпоративные и многостраничные проекты. Работаю как с программным кодом, так и с low-code платформами."
        :includes="includes"
        :audience="audience"
        :steps="steps"
        price="Стоимость разработки сайта — от 15 000 ₽. Сроки — от 3 рабочих дней."
    />
</template>

<script setup>
import ServicePageLayout from '@/components/cards/ServicePageLayout.vue';

const includes = [
    'лендинги, сайты-визитки и многостраничные сайты',
    'адаптивная разработка под мобильные, планшеты и десктоп',
    'разработка на Vue или low-code платформах',
    'настройка форм обратной связи и базового SEO',
    'помощь с публикацией сайта на хостинге',
];

const audience = [
    'малому бизнесу и самозанятым',
    'экспертам и частным специалистам',
    'компаниям, которым нужен современный сайт',
    'проектам, которым нужна индивидуальная разработка',
];

const steps = [
    'обсуждение задачи и целей сайта',
    'подготовка структуры и технического задания',
    'разработка дизайна или работа по готовому макету',
    'вёрстка, программирование и адаптация',
    'проверка, правки и публикация проекта',
];
</script>